import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingListSubHeaderComponent } from './booking-list-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BookingListSubHeaderComponent],
  imports: [CommonModule, TranslateModule, StaticMsgModule],
  exports: [BookingListSubHeaderComponent],
})
export class BookingListSubHeaderModule {}
